import request from '@/plugins/request'

export const loginByUsername = (account, password) => {
  return request({
    url: '/user/login',
    method: 'post',
    data: { account, password }
  })
}

export const loginByToken = () => {
  return request({
    url: '/user/session',
    method: 'post'
  })
}